import McDiyToggleChart from './McDiyToggleChart';

export default McDiyToggleChart;
